import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = '/api';

export function useChatPreferences(setMessages) {
  const [preferenceStats, setPreferenceStats] = useState(null);
  const [votingModelKey, setVotingModelKey] = useState('');

  const loadPreferenceStats = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/chat/preferences/stats`);
      setPreferenceStats(response.data);
    } catch {
      setPreferenceStats(null);
    }
  }, []);

  useEffect(() => {
    loadPreferenceStats();
  }, [loadPreferenceStats]);

  const handlePreferenceVote = useCallback(async (messageId, modelKey) => {
    setVotingModelKey(modelKey);
    try {
      const response = await axios.post(`${API}/chat/preferences`, {
        message_id: messageId,
        model_key: modelKey,
      });
      setMessages((current) =>
        current.map((message) =>
          message.id === messageId ? { ...message, preferred_model: response.data.preferred_model } : message
        )
      );
      setPreferenceStats(response.data.stats);
      toast.success('Préférence enregistrée');
    } catch {
      toast.error("Impossible d'enregistrer votre préférence");
    } finally {
      setVotingModelKey('');
    }
  }, [setMessages]);

  return {
    preferenceStats,
    votingModelKey,
    setPreferenceStats,
    handlePreferenceVote,
  };
}
